import { FORTA_BLACK } from '../../utils/colors';

import type { IconProps } from './types';

const ActiveIcon = (props: IconProps) => {
  const { color = FORTA_BLACK } = props;

  return (
    <svg width="15" height="15" viewBox="0 0 15 15" xmlns="http://www.w3.org/2000/svg">
      <path
        fill={color}
        d="M6.33166 14.0469C5.44054 13.9531 4.61097 13.7098 3.84296 13.317C3.07496 12.9242 2.40662 12.4141 1.83794 11.7868C1.26926 11.1595 0.820771 10.4413 0.492462 9.6323C0.164154 8.82326 0 7.96145 0 7.04688C0 5.97987 0.213987 4.99495 0.64196 4.0921C1.06993 3.18925 1.65327 2.41538 2.39196 1.77049H0.703518V0.363458H4.92462V4.58456H3.51759V2.66748C2.8727 3.18339 2.35972 3.81949 1.97864 4.57577C1.59757 5.33205 1.40704 6.15575 1.40704 7.04688C1.40704 8.48909 1.87898 9.7349 2.82286 10.7843C3.76675 11.8337 4.93635 12.4464 6.33166 12.6223V14.0469ZM6.03266 10.2831L3.0603 7.29311L4.04523 6.30818L6.03266 8.29562L10.0251 4.30316L11.01 5.30567L6.03266 10.2831ZM9.14573 13.7303V9.50919H10.5528V11.4263C11.1977 10.8986 11.7106 10.2596 12.0917 9.50919C12.4728 8.75877 12.6633 7.938 12.6633 7.04688C12.6633 5.60466 12.1914 4.35885 11.2475 3.30944C10.3036 2.26002 9.134 1.64738 7.73869 1.4715V0.046875C9.52094 0.222754 11.0218 0.973173 12.2412 2.29813C13.4606 3.62309 14.0704 5.206 14.0704 7.04688C14.0704 8.11388 13.8564 9.0988 13.4284 10.0016C13.0004 10.9045 12.4171 11.6784 11.6784 12.3233H13.3668V13.7303H9.14573Z"
      />
    </svg>
  );
};

export default ActiveIcon;
